import { render } from "./limitincrease.vue?vue&type=template&id=5355dc34"
import script from "./limitincrease.vue?vue&type=script&lang=js"
export * from "./limitincrease.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__